  <mb-dialog-header>
    <h3 class="mb-dialog-custom__header text" i18n="@@modals_imagemessage_informacion">
      Información
    </h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <p>
        Es responsabilidad de la cadena hotelera y/o de cada propietario individual
        asegurar la precisión de las fotos mostradas. Almundo no es responsable de
        cualquier imprecisión en las fotos.
      </p>
    </div>
  </mb-dialog-body>
